// extracted by mini-css-extract-plugin
module.exports = {"main":"e_B"};